import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { ErrorDetailResponse } from '@/types/apps/error-detail.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface ErrorDetailGraphQLServiceInterface {}

type ErrorDetailGraphQLListResponse = GqlListResponse<ErrorDetailResponse>;

export class ErrorDetailGraphQLService
    extends BaseService
    implements ErrorDetailGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'errorDetail';
    }

    public getFields(): Record<string, any> {
        return {
            code: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            errorTypeId: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
            severityLevelId: true,
            solution: true,
            errorType: {
                code: true,
                id: true,
                name: true,
            },
        };
    }

    public async index(query: string): Promise<ErrorDetailGraphQLListResponse> {
        return this.fetchGqlList<ErrorDetailGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('errorDetail', {
            userId: this.getQueryById(),
        });
    }
}
